var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "curriculum" },
    [
      _vm.list.length == 0
        ? _c("ComponentEmpty", { attrs: { title: "暂无我的课程", tips: "" } })
        : _c("div", [
            _c("div", { staticClass: "curriculum-tab" }, [
              _c("div", { staticClass: "curriculum-tab_title" }, [
                _c("p", [_vm._v("学年")]),
                _c("p", [_vm._v("学期")]),
                _c("p", [_vm._v("课程名称")]),
                _c("p", [_vm._v("授课老师")]),
                _c("p", [_vm._v("联系电话")]),
                _c("p", [_vm._v("考试方式")]),
              ]),
              _c(
                "div",
                { staticClass: "curriculum-tab_list" },
                _vm._l(_vm.list, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "curriculum-tab_list__item" },
                    [
                      _c("div", { staticClass: "year" }, [
                        _vm._v(_vm._s(item.start_year)),
                      ]),
                      _c(
                        "div",
                        { staticClass: "semester" },
                        _vm._l(item.son, function (itemToo, indexToo) {
                          return _c(
                            "div",
                            { key: indexToo, staticClass: "semester-list" },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    itemToo.start_semester == 1
                                      ? "上半学期"
                                      : "下半学期"
                                  )
                                ),
                              ]),
                              _c(
                                "ul",
                                _vm._l(
                                  itemToo.son,
                                  function (itemThree, indexThree) {
                                    return _c("li", { key: indexThree }, [
                                      _c("span", [
                                        _vm._v(_vm._s(itemThree.course_title)),
                                      ]),
                                      _c("span", [
                                        _vm._v(_vm._s(itemThree.teacher_title)),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(itemThree.teacher_mobile)
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("examTypeFilter")(
                                              itemThree.exam_type
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }